import './ourprojects.css';

const OurProjects = () => {
    return (
        <h1>OurProjects</h1>
    )
}

export default OurProjects;